import { InteractionAttributes } from '@loyalty/shared-common/profile-api-client';
import { TFunction } from 'i18next';

export function isInteractionDeleted(interaction: InteractionAttributes): boolean {
  return !!interaction.deletedAt;
}

export function formatInteractionLabel(interaction: InteractionAttributes, t: TFunction): string {
  if (isInteractionDeleted(interaction)) {
    return t('interactions.deleted', { name: interaction.name });
  }

  return interaction.name;
}

export function isInteractionSelectable(
  interaction: InteractionAttributes,
  selectedIds: string | string[] | null | undefined,
): boolean {
  if (!isInteractionDeleted(interaction)) {
    return true;
  }

  const selected = Array.isArray(selectedIds) ? selectedIds : selectedIds ? [selectedIds] : [];

  return selected.includes(interaction.id);
}
